import { cva } from 'cva';
export const infoBarVariants = cva({
    base: [
        '@px-3',
        '@py-2',
        '@text-grey-5',
        '@text-b2',
        '@flex',
        '@items-start',
    ],
    variants: {
        state: {
            info: ['@bg-attention1-2', '[&>[data-icon]]:@text-brand1-1'],
            success: ['@bg-success1-2', '[&>[data-icon]]:@text-success1-1'],
            error: ['@bg-error1-2', '[&>[data-icon]]:@text-red1-1'],
            warning: ['@bg-warning1-2', '[&>[data-icon]]:@text-warning1-1'],
        },
        rounded: {
            true: ['@rounded'],
            false: [],
        }
    },
    defaultVariants: {
        state: 'info',
        rounded: false,
    }
});
export const infoBarTitleVariants = cva({
    base: [
        '@text-b2',
        '@text-grey-5',
        '@flex',
        '@items-center',
    ],
    variants: {
        align: {
            left: [],
            center: ['@justify-center'],
        },
        variant: {
            normal: ['@text-grey-5'],
            emphasis: ['@text-grey-6', '@font-medium'],
        }
    },
    defaultVariants: { align: 'center' },
});
export const infoBarContainerClassNames = [
    '@flex-auto',
];
export const infoBarCloseClassNames = [
    '@flex-none',
    '@p-1',
    '@ml-2',
    '@-mt-px',
    '@leading-[0]',
    '@cursor-pointer',
    '@text-grey-6',
    '[&>svg]:@w-3.5',
    '[&>svg]:@h-3.5',
];
export const infoBarIconVariants = cva({
    base: [
        '[&>[data-icon]]:@w-5',
        '[&>[data-icon]]:@h-5',
        '@leading-[0]',
        '@mr-2',
    ],
    variants: {
        state: {
            info: ['[&>[data-icon]]:@text-brand1-1'],
            success: ['[&>[data-icon]]:@text-success1-1'],
            error: ['[&>[data-icon]]:@text-red1-1'],
            warning: ['[&>[data-icon]]:@text-warning1-1'],
        },
    },
});
export const infoBarContentClassNames = [
    '@flex-auto',
    '@text-b2',
    '@text-grey-5',
    '@ml-7',
];
export var InfoBarState;
(function (InfoBarState) {
    InfoBarState["info"] = "info";
    InfoBarState["success"] = "success";
    InfoBarState["error"] = "error";
    InfoBarState["warning"] = "warning";
})(InfoBarState || (InfoBarState = {}));
